<template>
  <modal
    class="login-modal"
    name="login"
    :width="380"
    height="auto"
    :adaptive="true"
    :click-to-close="false"
    transition="modal"
    @before-open="getParams"
    @before-close="beforeClose"
  >
    <login
      action="action"
      :type="type"
      :no-login-action="noLoginAction"
      :redirect-url="redirectUrl"
    ></login>
  </modal>
</template>
<script>
import Login from '@/components/Login.vue'
import get from 'lodash-es/get'
import { EventBus, Events } from '@/eventbus/EventBus'

export default {
  data() {
    return {
      action: '',
      type: '',
      noLoginAction: '',
      redirectUrl: undefined
    }
  },
  components: {
    Login
  },
  methods: {
    getParams(event) {
      this.redirectUrl = get(event.params, 'redirectUrl')
      this.action = get(event.params, 'action')
      this.type = get(event.params, 'type')
      this.noLoginAction = get(event.params, 'noLoginAction')
    },
    beforeClose() {
      if (!this.rootStore.loggedIn) {
        EventBus.emit(Events.LOGIN_CANCELLED)
      }

      if (this.action && this.rootStore.loggedIn) {
        this.action()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.login-modal {
  z-index: 1000;
}
</style>
